interface Artist {
  id: number
  name: string
  image: string
  description?: string
}

interface FeaturedArtistsProps {
  artists: Artist[]
}

const FeaturedArtists = ({ artists }: FeaturedArtistsProps) => {
  return (
    <section className="bg-gray-900 py-12 md:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-primary-light text-sm md:text-base font-semibold uppercase tracking-wider">
              Featured Artists
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
              Our Star Performers
            </h2>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
            {artists.map((artist) => (
              <div
                key={artist.id}
                className="group cursor-pointer"
              >
                <div className="relative aspect-square rounded-lg overflow-hidden mb-3">
                  <img
                    src={artist.image}
                    alt={artist.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                    {artist.description && (
                      <p className="text-white text-xs line-clamp-2">{artist.description}</p>
                    )}
                  </div>
                </div>
                <h3 className="text-white font-semibold text-sm md:text-base text-center group-hover:text-primary-light transition-colors">
                  {artist.name}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeaturedArtists

